import React, { JSX, useEffect, useRef } from "react";
import { useRouter } from "next/router";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import type { SwiperOptions } from "swiper/types";
import type { default as SwiperClass } from "swiper";
import Image from "next/image";
import { endpoints } from "config";
import { BRANDS } from "constants/brands";
import { getCloudflareLoader } from "@pepdirect/v3/helpers/cloudflareImages";
import st from "./st.module.scss";

/*
  Duplicating brands since otherwise it bugs :)
  https://github.com/nolimits4web/swiper/issues/2942#issuecomment-555365102
*/
const brandsDuplicated = BRANDS.concat(BRANDS);
export function HeroCarousel(): JSX.Element {
  /* We need this magic to "update" swiper after routing happens, otherwise swiper appears scrolled */
  const swiperReference = useRef<SwiperClass | null>(null);
  const router = useRouter();

  useEffect(() => {
    const updateSwiper = () => {
      if (swiperReference.current) {
        swiperReference.current.update();
      }
    };
    router.events.on("routeChangeComplete", updateSwiper);
    return () => {
      router.events.off("routeChangeComplete", updateSwiper);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const options: SwiperOptions = {
    slidesPerView: "auto" as const,
    freeMode: true,
    speed: 6000,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    loop: true,
  };

  return (
    <div className={st.wrapper}>
      <Swiper
        {...options}
        modules={[Autoplay]}
        className={st.swiperContainer}
        onSwiper={(current) => (swiperReference.current = current)}
      >
        {brandsDuplicated.map(({ name, logo }, index) => (
          <SwiperSlide key={`${name}-${index}`} className={st.slide}>
            <Image
              src={logo}
              width={80}
              height={80}
              loader={getCloudflareLoader(endpoints.cdn)}
              alt={name}
              style={{
                maxWidth: "100%",
                height: "auto",
              }}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
